/* eslint-disable max-lines */
import { pipe, clone, reject, isNil } from 'ramda';

import { clearGeo } from './clearGeo';
import { convertProperties } from './convertProperties';
import { removeGeo } from './removeGeo';
import { resetTerms } from './resetTerms';
import { selectGeo } from './selectGeo';
import { setDealType } from './setDealType';
import { setRoomTypes } from './setRoomTypes';
import {
  NonEmptyArray,
  FDealType,
  ERentTime,
  TJsonQueryOptionalKeys,
  ERoomType,
  TGeoValue,
  IJsonQuery,
  FOfferType,
} from './types';
import { unsetUnavailableProperties } from './unsetUnavailableProperties';
import { setRentalPeriod } from './setRentalPeriod';
import { setOfferType } from './setOfferType';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
const postprocessJsonQuery = pipe(unsetUnavailableProperties, convertProperties, reject(isNil)) as (
  x: IJsonQuery,
) => IJsonQuery;

export class JsonQuery {
  private jsonQuery: IJsonQuery;

  public constructor(jsonQuery: IJsonQuery) {
    this.jsonQuery = clone(jsonQuery);
  }

  public toJSON = () => clone(this.jsonQuery);

  public setJsonQuery = (jsonQuery: IJsonQuery): this => this.wrap(jsonQuery);
  public setOfferType = (offerType: FOfferType): this => this.wrap(setOfferType(this.jsonQuery)(offerType));
  public setDealType = (dealType: FDealType): this => this.wrap(setDealType(this.jsonQuery)(dealType));
  public setRoomTypes = (roomTypes: NonEmptyArray<ERoomType> | null): this =>
    this.wrap(setRoomTypes(this.jsonQuery)(roomTypes));
  public selectGeo = (...geoValues: NonEmptyArray<TGeoValue>): this =>
    this.wrap(selectGeo(this.jsonQuery)(...geoValues));
  public setRentalPeriod = (rentalPeriod: ERentTime | null): this =>
    this.wrap(setRentalPeriod(this.jsonQuery)(rentalPeriod));
  public removeGeo = (geoValue: TGeoValue): this => this.wrap(removeGeo(this.jsonQuery)(geoValue));
  public clearGeo = (): this => this.wrap(clearGeo(this.jsonQuery)());
  /*
   * TODO clearTag на данный пустой, нужно перенести все старые теги на новые рельсы.
   *  В итоге нужно чтобы теги он работали через модификаторы и не были привязаны напрямую к стору.
   *  Текущий пустой clearTag, который ничего не делает, нужен чтобы попадал модификатор в список
   *  lastAppliedModifiers и провоцировал отображение плашки об изменении фильтров с кнопкой "Применить".
   */
  public clearTag = (): this => this;
  public resetTerms = (terms: NonEmptyArray<TJsonQueryOptionalKeys>): this =>
    this.wrap(resetTerms(this.jsonQuery)(terms));

  private wrap = (nextJsonQuery: IJsonQuery) => {
    this.jsonQuery = postprocessJsonQuery(nextJsonQuery);

    return this;
  };
}
